import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'mapFilter'})
export class MapFilter implements PipeTransform {

  transform(items: any[], filter?: any): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter(item => item.indexOf(filter) === -1);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/filter/map.filter.ts